import React, { Fragment } from 'react'
import { Container, Row } from "reactstrap";
import { Col } from "react-bootstrap";
import { Breadcrumbs } from '../../AbstractElements';
import CollectionHome from './CollectionHome';

export default function CollectionList() {
    return (
        <Fragment>
            <Breadcrumbs mainTitle="List of Collections" parent="Home" title="List of Collections" />
            <Container fluid={true}>
                <Row>
                    <Col className="h-100">
                       <CollectionHome/>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}
